(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scamthread-product"]) return;
  try {
    
if (!customElements.get('sct-product')) {
  customElements.define('sct-product', class extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }
    init() {
      if (this.ready) return;
      this.ready = true;
      this.variants = JSON.parse(this.querySelector('[data-variants]').textContent);
      this.txt = JSON.parse(this.querySelector('[data-text]').textContent);
      this.groups = [...this.querySelectorAll('[data-opt]')];
      this.track = this.querySelector('.sct-track');
      this.slides = [...this.querySelectorAll('.sct-slide')];
      this.thumbs = [...this.querySelectorAll('[data-thumb]')];
      this.groups.forEach(g => g.addEventListener('change', () => this.update()));
      this.thumbs.forEach((t, i) => t.addEventListener('click', () => this.go(i, true)));
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.dots.forEach((d, i) => d.addEventListener('click', () => this.go(i, true)));
      this.mq = matchMedia('(max-width:900px)');
      this.mq.addEventListener('change', () => this.observe());
      this.addEventListener('wheel', e => this.onWheel(e), { passive: false });
      this.querySelectorAll('[data-step]').forEach(b => b.addEventListener('click', () => {
        const q = this.querySelector('[name=quantity]');
        q.value = Math.max(1, (parseInt(q.value, 10) || 1) + Number(b.dataset.step));
      }));
      this.markOut();
      this.observe();
      this.showMedia(this.current(), false);
      this.setupZoom();
      this.setupChart();
      this.setupCart();
    }
    disconnectedCallback() {
      if (this.lb) this.lb.remove();
      if (this.chart) this.chart.remove();
      document.documentElement.style.overflow = '';
    }
    setupZoom() {
      const mode = this.dataset.zoom || 'none';
      const hover = (mode === 'hover' || mode === 'both') && matchMedia('(hover:hover) and (pointer:fine)').matches;
      const box = mode === 'lightbox' || mode === 'both';
      this.slides.forEach((sl, i) => {
        const img = sl.querySelector('img');
        if (hover && img) {
          sl.addEventListener('mouseenter', () => sl.classList.add('is-zoom'));
          sl.addEventListener('mouseleave', () => sl.classList.remove('is-zoom'));
          sl.addEventListener('mousemove', e => {
            const r = sl.getBoundingClientRect();
            img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          });
        }
        if (box) sl.addEventListener('click', () => this.lbOpen(i));
      });
      const lb = this.lb = this.querySelector('[data-lb]');
      if (!lb) return;
      this.lbData = JSON.parse(this.querySelector('[data-lb-data]').textContent);
      this.lbView = lb.querySelector('[data-lb-view]');
      this.lbImg = lb.querySelector('[data-lb-img]');
      this.z = 1;
      document.body.appendChild(lb);
      const many = this.lbData.length > 1;
      lb.querySelectorAll('[data-lb-prev],[data-lb-next]').forEach(b => b.hidden = !many);
      lb.querySelector('[data-lb-close]').addEventListener('click', () => lb.close());
      lb.querySelector('[data-lb-prev]').addEventListener('click', () => this.lbShow(this.lbI - 1));
      lb.querySelector('[data-lb-next]').addEventListener('click', () => this.lbShow(this.lbI + 1));
      lb.querySelector('[data-lb-in]').addEventListener('click', () => this.lbZoom(this.z + 1, .5, .5));
      lb.querySelector('[data-lb-out]').addEventListener('click', () => this.lbZoom(this.z - 1, .5, .5));
      lb.addEventListener('keydown', e => {
        if (e.key === 'ArrowLeft') this.lbShow(this.lbI - 1);
        if (e.key === 'ArrowRight') this.lbShow(this.lbI + 1);
      });
      lb.addEventListener('close', () => { document.documentElement.style.overflow = ''; });
      const v = this.lbView;
      let drag = null;
      v.addEventListener('pointerdown', e => {
        if (e.pointerType !== 'mouse' || this.z === 1) return;
        drag = { x: e.clientX, y: e.clientY, l: v.scrollLeft, t: v.scrollTop, m: false };
        v.setPointerCapture(e.pointerId);
      });
      v.addEventListener('pointermove', e => {
        if (!drag) return;
        const dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (Math.abs(dx) + Math.abs(dy) > 4) drag.m = true;
        v.scrollLeft = drag.l - dx;
        v.scrollTop = drag.t - dy;
      });
      v.addEventListener('pointerup', () => { this.dragged = !!(drag && drag.m); drag = null; });
      v.addEventListener('click', e => {
        if (this.dragged) { this.dragged = false; return; }
        const r = v.getBoundingClientRect();
        this.lbZoom(this.z > 1 ? 1 : 2.5, (e.clientX - r.left) / r.width, (e.clientY - r.top) / r.height);
      });
    }
    lbOpen(i) {
      if (!this.lb) return;
      this.lbShow(i);
      document.documentElement.style.overflow = 'hidden';
      this.lb.showModal();
    }
    lbShow(i) {
      const n = this.lbData.length, d = this.lbData[((i % n) + n) % n];
      this.lbI = ((i % n) + n) % n;
      this.z = 1;
      this.lbImg.style.cssText = '';
      this.lbView.classList.remove('is-zoomed');
      this.lbView.scrollTo(0, 0);
      this.lbImg.src = d.src;
      this.lbImg.alt = d.alt || '';
      this.lb.querySelector('[data-lb-count]').textContent = (this.lbI + 1) + ' / ' + n;
    }
    lbZoom(z, fx, fy) {
      const v = this.lbView, img = this.lbImg;
      z = Math.max(1, Math.min(4, z));
      if (z === this.z) return;
      const r = img.getBoundingClientRect(), vr = v.getBoundingClientRect();
      if (this.z === 1) this.fitW = r.width;
      const px = Math.min(1, Math.max(0, (vr.left + fx * vr.width - r.left) / r.width));
      const py = Math.min(1, Math.max(0, (vr.top + fy * vr.height - r.top) / r.height));
      this.z = z;
      if (z === 1) { img.style.cssText = ''; v.classList.remove('is-zoomed'); v.scrollTo(0, 0); return; }
      img.style.maxWidth = 'none';
      img.style.maxHeight = 'none';
      img.style.width = (this.fitW * z) + 'px';
      img.style.height = 'auto';
      v.classList.add('is-zoomed');
      const n = img.getBoundingClientRect();
      v.scrollLeft += (n.left + px * n.width) - (vr.left + fx * vr.width);
      v.scrollTop += (n.top + py * n.height) - (vr.top + fy * vr.height);
    }
    setupCart() {
      const form = this.querySelector('form.sct-form');
      if (!form) return;
      form.addEventListener('submit', async e => {
        const atc = this.querySelector('[data-atc]');
        if (e.submitter && !e.submitter.matches('[data-atc]')) return;
        e.preventDefault();
        if (this.adding || (atc && atc.disabled)) return;
        this.adding = true;
        if (atc) atc.setAttribute('aria-busy', 'true');
        const old = form.querySelector('.sct-err');
        if (old) old.remove();
        const drawer = document.querySelector('cart-drawer');
        if (drawer && drawer.setActiveElement) drawer.setActiveElement(document.activeElement);
        try {
          const fd = new FormData(form);
          if (drawer && drawer.getSectionsToRender) {
            fd.append('sections', drawer.getSectionsToRender().map(x => x.id).join(','));
            fd.append('sections_url', window.location.pathname);
          }
          const res = await fetch((window.routes && window.routes.cart_add_url) || '/cart/add', {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
            body: fd
          });
          const data = await res.json();
          if (data.status) {
            const msg = document.createElement('p');
            msg.className = 'sct-err';
            msg.setAttribute('role', 'alert');
            msg.textContent = data.description || data.message || 'Could not add to cart';
            (atc.closest('.sct-buy') || form).after(msg);
          } else {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: fd.get('id'), cartData: data });
            }
            if (drawer && drawer.renderContents) {
              drawer.classList.remove('is-empty');
              drawer.renderContents(data);
            } else {
              window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            }
          }
        } catch (err) {
          console.error(err);
          this.adding = false;
          if (atc) atc.removeAttribute('aria-busy');
          form.submit();
          return;
        }
        this.adding = false;
        if (atc) atc.removeAttribute('aria-busy');
      });
    }
    setupChart() {
      const d = this.chart = this.querySelector('[data-chart]');
      if (!d) return;
      document.body.appendChild(d);
      this.querySelectorAll('[data-open-chart]').forEach(b => b.addEventListener('click', () => d.showModal()));
      d.querySelector('[data-chart-close]').addEventListener('click', () => d.close());
      d.addEventListener('click', e => { if (e.target === d) d.close(); });
    }
    layout() { return this.dataset.layout || 'slider'; }
    framed() { return !this.mq.matches && this.dataset.frame === 'true'; }
    horizontal() {
      return this.mq.matches ? ['slider', 'thumbs'].includes(this.dataset.mlayout || 'slider') : ['slider', 'below'].includes(this.layout());
    }
    inside() { return this.horizontal() || this.framed(); }
    onWheel(e) {
      if (e.ctrlKey || this.dataset.wheel !== 'true' || !this.framed() || this.horizontal()) return;
      const t = this.track;
      if (t.contains(e.target) || e.target.closest('.sct-thumbs')) { this.gliding = false; return; }
      const r = t.getBoundingClientRect();
      const seen = Math.min(r.bottom, innerHeight) - Math.max(r.top, 0);
      if (seen < Math.min(r.height * 0.6, 320)) return;
      const dy = e.deltaMode === 1 ? e.deltaY * 16 : e.deltaY;
      const pos = this.gliding ? this.goal : t.scrollTop;
      const max = t.scrollHeight - t.clientHeight;
      if ((dy > 0 && pos < max - 1) || (dy < 0 && pos > 1)) {
        e.preventDefault();
        this.glide(pos + dy, max);
      }
    }
    glide(to, max) {
      const t = this.track;
      this.goal = Math.max(0, Math.min(max, to));
      if (this.gliding) return;
      this.gliding = true;
      const step = () => {
        if (!this.gliding) return;
        const d = this.goal - t.scrollTop;
        if (Math.abs(d) < 1) { t.scrollTop = this.goal; this.gliding = false; return; }
        t.scrollTop += Math.sign(d) * Math.max(1, Math.abs(d) * 0.22);
        requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }
    picked() { return this.groups.map(g => g.querySelector('input:checked')?.value); }
    current() {
      if (!this.groups.length) return this.variants[0];
      const p = this.picked();
      return this.variants.find(v => v.options.every((o, i) => o === p[i]));
    }
    markOut() {
      const p = this.picked();
      this.groups.forEach((g, gi) => g.querySelectorAll('input').forEach(inp => {
        const t = [...p]; t[gi] = inp.value;
        const v = this.variants.find(x => x.options.every((o, i) => o === t[i]));
        inp.nextElementSibling.classList.toggle('is-out', !v || !v.available);
      }));
    }
    update() {
      const v = this.current();
      this.groups.forEach(g => {
        const c = g.querySelector('input:checked');
        g.querySelector('[data-selected]').textContent = c ? (c.dataset.label || c.value) : '';
      });
      this.markOut();
      const btn = this.querySelector('[data-atc]');
      const stock = this.querySelector('[data-stock]');
      const now = this.querySelector('[data-now]');
      const was = this.querySelector('[data-was]');
      const badge = this.querySelector('[data-badge]');
      if (!v) {
        btn.disabled = true; btn.textContent = this.txt.na; if (stock) stock.textContent = this.txt.na;
        return;
      }
      const idEl = this.querySelector('[data-id]');
      idEl.value = v.id;
      idEl.dispatchEvent(new Event('change', { bubbles: true }));
      now.textContent = v.price;
      was.textContent = v.was || '';
      was.hidden = !v.was;
      if (badge) badge.hidden = !v.was;
      const pctEl = this.querySelector('[data-pct]');
      if (pctEl) {
        pctEl.textContent = (pctEl.dataset.tpl || '{percent}% OFF').replace(/\{percent\}/g, v.pct);
        pctEl.hidden = !(v.was && v.pct > 0);
      }
      btn.disabled = !v.available;
      btn.textContent = v.available ? this.txt.add : this.txt.out;
      if (stock) stock.textContent = v.available ? this.txt.stock : this.txt.out;
      const u = new URL(location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u);
      this.showMedia(v, true);
    }
    showMedia(v, smooth) {
      if (!v || !v.media || !this.inside()) return;
      const i = this.slides.findIndex(s => Number(s.dataset.media) === v.media);
      if (i > -1) this.go(i, smooth);
    }
    go(i, smooth) {
      const s = this.slides[i];
      if (!s) return;
      const behavior = smooth ? 'smooth' : 'auto';
      if (this.horizontal()) this.track.scrollTo({ left: s.offsetLeft, behavior });
      else if (this.framed()) this.track.scrollTo({ top: s.offsetTop, behavior });
      else s.scrollIntoView({ behavior, block: 'start' });
    }
    observe() {
      if (this.io) this.io.disconnect();
      this.ratios = new Map();
      this.io = new IntersectionObserver(entries => {
        entries.forEach(e => this.ratios.set(e.target, e.intersectionRatio));
        let best = -1, idx = 0;
        this.slides.forEach((s, i) => {
          const r = this.ratios.get(s) || 0;
          if (r > best + 0.001) { best = r; idx = i; }
        });
        this.setActive(idx);
      }, { root: this.inside() ? this.track : null, threshold: [0, .25, .5, .75, 1] });
      this.slides.forEach(s => this.io.observe(s));
    }
    setActive(i) {
      this.thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
      this.dots.forEach((d, k) => {
        d.classList.toggle('is-active', k === i);
        d.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      this.querySelector('[data-count]').textContent = (i + 1) + ' / ' + this.slides.length;
      const t = this.thumbs[i], bar = t && t.closest('.sct-thumbs');
      if (bar && bar.offsetParent) {
        const b = bar.getBoundingClientRect(), r = t.getBoundingClientRect();
        bar.scrollTop += (r.top - b.top) - (b.height - r.height) / 2;
        bar.scrollLeft += (r.left - b.left) - (b.width - r.width) / 2;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
